module.exports = ['screen', 'window', 'tab', 'browser', 'application'];
